import type { Licence } from '~/types/licence'
import type { EndpointsRegistry, FetchClient } from '~/api/types'
import { GatewayEndpoints } from '~/api/endpoints/gateway-endpoints'

export interface LicensesService {
  getLicenses: () => Promise<Licence[]>
}

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): LicensesService => {
  return {
    getLicenses: async () => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.LICENSES_GET_ALL)
      return await client<Licence[]>(url, { method, headers, body })
    }
  }
}
